import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import FormPage from '@/components/FormPage'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/', 
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/form', 
      name: 'FormPage',
      component: FormPage,
      meta: {
        requireAuth: true 
      }
    },
    {
      path: '*', 
      redirect: '/login'
    }
  ]
})